import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import axios from "../../API/axios";
import moment from "moment";
import Bookmark from "../../khojpages/Searchjob/Bookmark";
import ApplyJob from "../../khojpages/Searchjob/ApplyJob";
import WorkSharpIcon from '@mui/icons-material/WorkSharp';
import Tooltip from "@mui/material/Tooltip";


Job03.propTypes = {};

function Job03() {
	const token = localStorage.getItem('token')
	const userType = localStorage.getItem("userType");

	const [candidateDataUpdated, setCandidateDataUpdated] = useState(null);
	// ...............................All Job List.......................................

	const [jobList, setjobList] = useState([]);
	const [isLoading, setIsLoading] = useState(true);

	const getAlljobList = (page) => {
		const data =
		{
			pageNumber: page,
			pageSize: 10,
		};
		axios
			.get(`/Job/GetFeaturedJobs`, data)
			.then((response) => {

				const res = response.data.responseData;
				// console.log("getAlljobList", response.data.responseData.jobsList);
				setjobList(res);
				setIsLoading(false);

			})
			.catch((error) => {
				console.log("error", error)
			});
	};

	useEffect(() => {
		getAlljobList(); // Initial fetch on mount
	}, [candidateDataUpdated]);

	// ...............................All Jobs List.......................................

	// Money Format at Code Language Start
	const formatSalary = (salary) => {
		if (salary >= 10000000) {
			return (salary / 10000000).toFixed(1) + 'Cr'; // 'Cr' for crore
		} else if (salary >= 100000) {
			return (salary / 100000).toFixed(1) + 'L'; // 'L' for lakh (includes 10L for 1M)
		} else if (salary >= 1000) {
			return (salary / 1000).toFixed(1) + 'k'; // 'k' for thousand
		} else {
			return salary; // Return as is for values less than 1000
		}
	};
	// Money Format at Code Language End

	// .................................shortDescription
	const addTargetBlankToAnchors = (html) => {
		const div = document.createElement('div');
		div.innerHTML = html;

		const anchors = div.querySelectorAll('a');
		anchors.forEach(anchor => {
			anchor.setAttribute('target', '_blank');
			anchor.setAttribute('rel', 'noopener noreferrer');
		});

		return div.innerHTML;
	};


	const linkifyContent = (htmlContent) => {
		const urlPattern = /(?<!href="|">)(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
		return htmlContent.replace(urlPattern, function (url) {
			return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
		});
	};
	// .................................shortDescription

	// .................................................................................
	// .................................................................................
	const truncateText = (text, maxLength) => {
		if (!text) return '';
		return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
	};

	// .................................................................................
	// .................................................................................

	return (

		<>
			{jobList.length === 0 ? "" : (

				<section className="container topJobsHome ">
					{/* <Tabs className="wrap-testimonials over-flow-hidden tf-tab"> */}
					<div className="container">
						<div className="tf-title style-2">
							<div className="group-title pt-0">
								<h1>Featured Jobs</h1>
								<p className="text-center">Find the job that's perfect for you. About 800+ new jobs everyday</p>
							</div>

						</div>
						<div className="row content-tab wow fadeInUp jobs-tab">
							{jobList.map((data) => (
								<div key={data.id} className="col-lg-6 d-flex align-items-stretch Candidate-Featured-Jobs-Cards">
									<Link
										to={`/job/${data.jobId}`}
										className="w-100"
									>
										<div className="features-job w-100 h-100 features-job-zerothree">
											{/* <div to="/Jobs" className="btn-category-job"> */}
											<div className="job-archive-header">
												<div className="inner-box">
													<div className="logo-company">
														<img src={data.compImage} alt="User Logo" />
														{/* <img src={data.img} alt="User Logo" /> */}
													</div>
													<div className="box-content">
														<div className="d-flex justify-content-between align-items-center ">
															<h4 className="mb-0 ">
																{token === null ? (
																	data.compName
																) : (
																	data.compType === "Company" ? (
																		<Link to={`/Company/${data.compUid}`}>{data.compName}</Link>
																	) : (
																		<>
																			<Link to={`/Recruiter/${data.compUid}`}>{data.compName}</Link>
																			<span className="rec-badge-purple ms-2">{data.compType}</span>

																		</>
																	)
																)}
															</h4>
															<div
																onClick={(e) => {
																	e.preventDefault();
																	e.stopPropagation();
																}}	>
																<Bookmark
																	jobId={data.jobId}
																	issavedbyyou={data.isSaved}
																	className="m-0"
																/>
															</div>
														</div>
														<h3 className="mb-0 d-flex justify-content-between">
															<Link to={`/job/${data.jobId}`}> {data.title} </Link>
															{/* <div className="row">
																	<span className="f-16 d-flex align-center">
																		<WorkSharpIcon className="f-18  me-2" />
																		{data.jobAppliedCount}</span>
																</div> */}

														</h3>
														<ul className="ps-0">
															{data.cityName === null ? '' : (

																<li>
																	<span className="icon-map-pin"></span>
																	&nbsp;
																	{data.cityName}
																</li>
															)}
															{data.creationTime === null ? '' : (

																<li>
																	<span className="icon-calendar"></span>
																	&nbsp;
																	{moment
																		.utc(data.creationTime)
																		.local()
																		.format("DD MMMM YYYY")}
																</li>
															)}
														</ul>
													</div>
												</div>
												<p className="alljobs-about-card"
													dangerouslySetInnerHTML={{
														__html: linkifyContent(
															addTargetBlankToAnchors(data.shortDescription.replace(/●/g, ''))
														)
													}}
												>
													{/* {data.shortDescription} */}
												</p>

											</div>
											<div className="job-archive-footer">
												<div className="job-footer-left">
													<ul className="job-tag Job-Footer-Small-Button">
														{data.jbTypName === "" || data.jbTypName === null ? "" : (
															<li>
																<Link
																	style={{ pointerEvents: "none" }}
																	onClick={(e) => e.preventDefault()} // Prevents navigation
																>{data.jbTypName}</Link>
															</li>
														)}
														{data.workLevelTypename === "" || data.workLevelTypename === null ? "" : (
															<li>
																<Link to="#/"
																	style={{ pointerEvents: "none" }}
																	onClick={(e) => e.preventDefault()} // Prevents navigation
																>{data.workLevelTypename}</Link>
															</li>
														)}
														{data.workLocationTypeName === "" || data.workLocationTypeName === null ? "" : (
															<li>
																<Link to="#/"
																	style={{ pointerEvents: "none" }}
																	onClick={(e) => e.preventDefault()} // Prevents navigation
																>{data.workLocationTypeName}</Link>
															</li>
														)}
														{data.designationName === "" || data.designationName === null ? "" : (
															<li>
																<Link to="#/"
																	style={{ pointerEvents: "none" }}
																	onClick={(e) => e.preventDefault()} // Prevents navigation
																>{data.designationName}</Link>
															</li>
														)}
													</ul>
												</div>
												<div className="job-footer-right">
													<div className="price">
														<p className="mb-0">
															<span style={{ paddingRight: "4px" }} className="currencycapitalized">
																{data.currency}
															</span>
															{formatSalary(data.maxSalary)}

															<Tooltip title={data.salaryTypeName} arrow>
																{/* / {data.salaryTypeName} */}
																/{truncateText(data.salaryTypeName, 10)}
																<span className="year"></span>
															</Tooltip>
														</p>
													</div>
													<p className="days mb-0">{data.apply}</p>
													<div
														className="view-applybtn"
														onClick={(e) => {
															e.preventDefault();
															e.stopPropagation();
														}}	>
														<ApplyJob
															jobId={data.jobId}
															isAppliedByYou={data.isApplied}
															instituteAppliedJobsInfo={
																data.instituteAppliedJobsInfo
															}
															getAlljobList={getAlljobList}
															setCandidateDataUpdated={setCandidateDataUpdated}
														/>
														{/* {userType === "Candidate" ? (
																<ApplyjobAsCandidate
																	jobId={data?.jobId}
																	isAppliedByYou={data?.isApplied}
																	setCandidateDataUpdated={setCandidateDataUpdated}
																	getAlljobList={getAlljobList}
																/>
															) : userType === "Institution" ? (
																// <ApplyjobAsCandidate jobId={jobData?.jobId} isAppliedByYou={jobData?.isApplied} />
																<ApplyjobAsInstitute
																	jobId={data?.jobId}
																	isAppliedByYou={data?.isApplied}
																	instituteAppliedJobsInfo={instituteAppliedJobsInfo}
																	getAlljobList={getAlljobList}
																/>
															) : ""} */}
													</div>
												</div>
											</div>
											{/* </div> */}
										</div>
									</Link>
								</div>
							))}
							<div className="d-flex justify-content-center mt-2">
								<div className="khojPrimaryBtn" style={{ width: '192px', height: '50px' }}>
									<Link to="/Jobs" className="" >See More Jobs</Link>
								</div>
							</div>
						</div>
					</div>
					{/* </Tabs> */}
				</section >
			)
			}
		</>

	);
}

export default Job03;
